import { Button } from '@mui/material'
import React, { useRef } from 'react'
import style from './sec6.module.css'
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { doApiGet } from '../../../services/apiService';
export const Sec6 = () => {
    const regEmail = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    // const sendEmail = (formData) => {
    //     console.log(formData)
    //     emailjs
    //         .send('service_ngn745c', 'template_t0axzps', formData, 'oKr7l8ZRMKBwIt8NV')
    //         .then(
    //             (result) => {
    //                 console.log(result.text);
    //                 toast.success('פרטיך נשלחו ויחזרו אליך בהקדם')
    //             },
    //             (error) => {
    //                 console.log(error.text);
    //             }
    //         );
    //     reset();
    // };

    const onSub = async (bodyData) => {
        console.log(bodyData)
        try {
            const url = `https://api.leadmanager.co.il/handlers/lm/submit.cms?lm_form=61445&lm_key=271cc5a97cf1441fa481a1241a42d2f6&fld_34379=${bodyData.fullName}&fld_34344=${bodyData.phone}&fld_34380=${bodyData.email}&fld_34381=Fullstack&lm_supplier={מספר ספק}&lm_bc={כלי פרסומי}`
            const data = await doApiGet(url)
            console.log(data)
            if (data.status == 200) {
                toast.success(`${bodyData.fullName} פרטיך נשלחו ויחזרו אליך בהקדם`)
                reset()
            }
        } catch (err) {
            console.log(err.response)
            if (err) {
                toast.error("משהו לא הסתדר נסה שוב")
            }
        }
    }
    return (
        <div className={style.sec6}>
            <div className={style.container}>
                <h4 className={style.h4}>נא מלאו את פרטיכם לבדיקת התאמה</h4>

                <form onSubmit={handleSubmit(onSub)} >
                    <div className={style.row}>

                        <div className={style.inputBox}>
                        <input   {...register("fullName", { required: true })} placeholder='שם מלא' name="fullName" type="text" className={style.input} />

                            {errors.fullName && <span className={style.error}>שדה זה חובה</span>}
                        </div>
                        <div className={style.inputBox}>
                        <input  {...register("phone", { required: true })} name="phone" placeholder='טלפון נייד' type="text" className={style.input + " " + style.inputLtr} />
                            {errors.phone && <span className={style.error}>שדה זה חובה</span>}
                        </div>
                        <div className={style.inputBox}>
                        <input  {...register("email", { required: true, pattern: regEmail })} name="email" dir='ltr' placeholder='כתובת דוא״ל' type="email" className={style.input + " " + style.inputLtr} />

                            {errors.email && <span className={style.error}>שדה זה חובה</span>}
                        </div>
                    </div>

                    <div className={style.btnBox}>
                        <Button type='submit' variant='contained' className={style.syllabusBtn}>שלח/י טופס</Button>
                    </div>
                </form>
            </div>
            

        </div>
    )
}
